import {Injectable} from '@angular/core';
import {ApiService} from '@abstract/api.service';

@Injectable()
export class TechnicalDeviceElementTypeApiService extends ApiService {
    baseUrl = 'technical-device-element-type';

    getParamsPath(typeId: number, ntdId: number): string {
        return `${this.baseUrl}/${typeId}/params?ntd_id=${ntdId}`;
    }
}
